import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ConversationEffects } from './conversation.effects';
import { initialState, reducer } from './conversation.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('conversation', reducer, { initialState }),
    EffectsModule.forFeature([ConversationEffects]),
  ],
  providers: [ConversationEffects],
})
export class ConversationStoreModule {}
